export const languageList = [
  { text: 'KOR', langCode: 'ko' },
  { text: 'ENG', langCode: 'en' },
  { text: 'CHN', langCode: 'zh' },
];
